import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { monthCheckMs } from "../constants";

// De maand staat in de URL en die verandert uit zichzelf niet. Op een tv die
// maandenlang aan blijft staan betekent dat: op 1 oktober hangt september nog
// steeds op de muur, met "0 dagen te gaan" eronder, tot iemand herlaadt.
//
// Staat het scherm op de lopende maand, dan schuiven we bij de maandwissel
// vanzelf mee. Heeft iemand bewust een oudere maand opgezocht via de
// kalender in de navbar, dan laten we dat met rust: dan is dit effect niet
// eens actief.
export function useMonthRollover(month, year) {
  const navigate = useNavigate();

  useEffect(() => {
    const now = new Date();
    const showsToday =
      Number(month) === now.getMonth() + 1 && Number(year) === now.getFullYear();
    if (!showsToday) return undefined;

    const timer = setInterval(() => {
      const today = new Date();
      const thisMonth = today.getMonth() + 1;
      const thisYear = today.getFullYear();
      if (Number(month) === thisMonth && Number(year) === thisYear) return;
      navigate(`/dashboard/${thisMonth}/${thisYear}`, { replace: true });
    }, monthCheckMs);

    return () => clearInterval(timer);
  }, [month, year, navigate]);
}
